// extracted by mini-css-extract-plugin
module.exports = {"blockPlug":"plug_blockPlug__2CGbr","plugContent":"plug_plugContent__3LSOw","plugContentText":"plug_plugContentText__2wNNe","plugIcon":"plug_plugIcon__3cgGW"};